var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCredits(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lrffjbrcka",
    d: "M0 0h93.062v8.365H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nqgf9qxm9c",
    d: "M0 0h127.328v225.268H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nutu1ul7je",
    d: "M0 0h127.328v225.268H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w3oykrdfhg",
    d: "M0 0h83.222v6.199H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v360H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 318.305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9ckbg6q0ib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lrffjbrcka"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.062 4.183c0 2.31-20.833 4.182-46.531 4.182S0 6.492 0 4.183C0 1.873 20.833 0 46.53 0s46.531 1.873 46.531 4.183",
    fill: "#E3E5EB",
    mask: "url(#9ckbg6q0ib)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.999 320.25c0 2.566-41.92 4.647-93.633 4.647-51.711 0-93.632-2.081-93.632-4.648 0-2.566 41.921-4.647 93.632-4.646 51.712 0 93.633 2.08 93.633 4.647",
    fill: "#E3E5EB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.018 96)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e23qw6l96d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nqgf9qxm9c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.14 225.268H8.188c-4.503 0-8.188-3.684-8.188-8.188V8.188C0 3.685 3.685 0 8.188 0H119.14c4.503 0 8.188 3.685 8.188 8.188V217.08c0 4.504-3.685 8.188-8.188 8.188",
    fill: "#333E69",
    mask: "url(#e23qw6l96d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.703 96)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3f0wskml7f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nutu1ul7je"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.14 225.268H8.188c-4.503 0-8.188-3.684-8.188-8.188V8.188C0 3.685 3.685 0 8.188 0H119.14c4.503 0 8.188 3.685 8.188 8.188V217.08c0 4.504-3.685 8.188-8.188 8.188",
    fill: "#6470A1",
    mask: "url(#3f0wskml7f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.42 310.04H143.223c-.665 0-1.204-.538-1.204-1.204V107.17c0-.665.54-1.205 1.204-1.205h116.199c.665 0 1.204.54 1.204 1.205v201.666c0 .666-.539 1.205-1.204 1.205",
    fill: "#CAD1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.95 204.3h-66.116c-2.856 0-5.192-2.337-5.192-5.193V147.41c0-2.856 2.336-5.193 5.192-5.193h66.117c2.856 0 5.192 2.337 5.192 5.193v51.696c0 2.856-2.336 5.193-5.192 5.193M238.082 284.463H176.6a4.843 4.843 0 0 1-4.829-4.83v-48.072a4.843 4.843 0 0 1 4.829-4.829h61.483a4.843 4.843 0 0 1 4.829 4.829v48.073a4.843 4.843 0 0 1-4.829 4.829",
    fill: "#A3AED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.15 201.14h-75.492c-3.26 0-5.928-2.668-5.928-5.93v-59.025c0-3.262 2.668-5.93 5.928-5.93h75.492c3.261 0 5.93 2.668 5.93 5.93v59.026c0 3.26-2.669 5.929-5.93 5.929",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.714 161.948c1.157 14.68-9.806 27.52-24.486 28.677-14.681 1.157-27.52-9.806-28.678-24.486-1.157-14.681 9.806-27.52 24.486-28.678 14.681-1.157 27.52 9.806 28.678 24.487",
    fill: "#FFCCAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.417 162.602c.779 9.876-6.596 18.514-16.473 19.292-9.876.779-18.514-6.596-19.293-16.473-.778-9.876 6.597-18.514 16.474-19.292 9.876-.779 18.514 6.596 19.292 16.473",
    fill: "#F9A56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.574 172.822c-1.904-.158-3.817-1.089-5.077-2.235l1.111-1.706c1.29 1.086 2.815 1.962 4.629 1.943 2.198-.024 3.286-1.254 3.266-3.097-.05-4.815-8.332-3.686-8.393-9.482-.028-2.646 1.675-4.566 4.257-4.98l-.032-3.001 1.784-.02.03 2.943c1.905.188 3.163 1.096 4.245 2.214l-1.292 1.47c-1.112-1.058-2.04-1.672-3.644-1.655-1.813.019-2.96 1.16-2.942 2.885.045 4.31 8.326 3.033 8.394 9.423.03 2.823-1.733 4.804-4.553 5.22l.031 3.002-1.783.019-.031-2.943zM177.715 149.569c-.455 1.38-1.186 2.954-2.305 3.836-.477.375-.404 1.114.118 1.422 1.017.6 2.344 1.555 3.344 2.894a.868.868 0 0 0 1.528-.245 9.528 9.528 0 0 1 2.12-3.602.864.864 0 0 0-.213-1.345c-.876-.481-2.084-1.404-2.997-3.1a.87.87 0 0 0-1.595.14M247.807 280.68h-66.843c-2.888 0-5.25-2.362-5.25-5.25v-52.264c0-2.887 2.362-5.25 5.25-5.25h66.843c2.887 0 5.25 2.363 5.25 5.25v52.265c0 2.887-2.363 5.25-5.25 5.25",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68 245.978c1.025 12.999-8.682 24.367-21.68 25.392-13 1.025-24.368-8.682-25.393-21.68-1.024-13 8.682-24.368 21.681-25.393 13-1.025 24.368 8.682 25.393 21.681",
    fill: "#B4C3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.334 246.557c.69 8.745-5.84 16.393-14.585 17.083-8.746.69-16.394-5.841-17.083-14.586-.69-8.745 5.84-16.393 14.586-17.082 8.745-.69 16.393 5.84 17.082 14.585",
    fill: "#92A5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65 255.607c-1.686-.14-3.38-.964-4.496-1.979l.985-1.51c1.142.961 2.492 1.737 4.098 1.72 1.946-.021 2.91-1.11 2.892-2.742-.045-4.263-7.377-3.265-7.432-8.396-.024-2.343 1.483-4.043 3.77-4.41l-.029-2.657 1.58-.017.027 2.605c1.686.167 2.8.97 3.758 1.96l-1.144 1.303c-.984-.937-1.805-1.482-3.227-1.466-1.604.017-2.62 1.027-2.605 2.554.04 3.816 7.373 2.685 7.433 8.343.026 2.5-1.535 4.254-4.032 4.623l.028 2.658-1.579.017-.027-2.606zM200.493 235.017c-.403 1.223-1.05 2.616-2.041 3.397-.422.332-.358.987.105 1.26.9.53 2.075 1.377 2.96 2.562a.768.768 0 0 0 1.354-.217 8.438 8.438 0 0 1 1.877-3.19.765.765 0 0 0-.189-1.19c-.775-.426-1.845-1.244-2.653-2.746a.77.77 0 0 0-1.413.124",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.492 246.967c-13.604-7.885-22.754-22.604-22.754-39.459A45.361 45.361 0 0 1 168.882 183M225.052 165.515c16.358 6.918 27.835 23.115 27.835 41.993 0 4.518-.657 8.883-1.882 13.004",
    stroke: "#4A476B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A476B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m248.653 216.2 1.684 5.939 4.678-3.493M169.615 188.616l-.816-6.118-5.13 2.787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1 134.807c0 7.136-5.784 12.92-12.92 12.92-7.135 0-12.92-5.784-12.92-12.92 0-7.135 5.785-12.92 12.92-12.92 7.136 0 12.92 5.785 12.92 12.92",
    fill: "#5C77D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.275 133.061 3.011 5.797 9.684-5.797",
    stroke: "#FFF",
    strokeWidth: 5.187,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.85 223.403-50.774-.54c-3.316-.036-6.501 2.585-7.08 5.823l-15.683 87.88c-.578 3.238 1.662 5.916 4.977 5.951l50.774.541c3.316.035 6.501-2.585 7.079-5.824l15.684-87.88c.578-3.238-1.662-5.916-4.977-5.951",
    fill: "#364270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.356 330.773c0 2.887-20.833 5.227-46.531 5.227-25.699 0-46.531-2.34-46.531-5.227 0-2.887 20.832-5.227 46.53-5.227 25.7 0 46.532 2.34 46.532 5.227",
    fill: "#E3E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.155 229.355-15.683 87.88c-.578 3.237-3.764 5.858-7.08 5.823l-50.773-.54c-3.315-.036-5.555-2.714-4.977-5.952l15.684-87.88c.578-3.238 3.763-5.859 7.078-5.824l50.774.54c3.316.036 5.555 2.714 4.977 5.953",
    fill: "#627DD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.362 298.02c4.638.05 7.742 3.762 6.934 8.293-.809 4.53-5.224 8.162-9.862 8.113-4.639-.05-7.743-3.762-6.935-8.292.809-4.53 5.224-8.163 9.863-8.113M115.057 238.124l-2.873 16.097c-.525 2.943-3.42 5.325-6.434 5.293l-6.015-.064c-3.014-.032-5.05-2.466-4.524-5.41l2.872-16.097c.526-2.943 3.421-5.325 6.435-5.293l6.015.064c3.014.032 5.05 2.466 4.524 5.41",
    fill: "#405AB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.667 288.834-4.4 24.65c-.132.744-.863 1.346-1.624 1.338-.761-.008-1.276-.623-1.143-1.366l4.4-24.651c.132-.744.863-1.345 1.625-1.337.76.008 1.275.623 1.142 1.366M137.39 234.354l-4.4 24.65c-.132.744-.863 1.346-1.624 1.338-.761-.009-1.275-.624-1.143-1.367l4.4-24.65c.132-.744.864-1.346 1.625-1.338.76.009 1.275.623 1.142 1.367M92.987 233.881l-4.399 24.651c-.133.743-.864 1.345-1.625 1.337-.761-.008-1.275-.623-1.143-1.366l4.4-24.651c.132-.743.864-1.345 1.625-1.337.761.008 1.275.623 1.142 1.366M116.492 301.039l-1.963 10.999c-.266 1.486-1.728 2.69-3.25 2.673-1.523-.016-2.551-1.246-2.286-2.732l1.963-10.999c.266-1.487 1.728-2.69 3.25-2.674 1.523.017 2.551 1.246 2.286 2.733M120.4 279.137l-1.963 10.999c-.265 1.487-1.727 2.69-3.25 2.673-1.522-.016-2.55-1.245-2.285-2.732l1.963-10.999c.265-1.487 1.728-2.69 3.25-2.673 1.522.016 2.55 1.245 2.285 2.732M124.31 257.235l-1.964 10.999c-.265 1.487-1.728 2.69-3.25 2.674-1.522-.017-2.55-1.246-2.285-2.733l1.963-10.999c.265-1.487 1.728-2.69 3.25-2.673 1.522.016 2.55 1.245 2.285 2.732M128.218 235.333l-1.963 11c-.265 1.486-1.728 2.689-3.25 2.673-1.522-.016-2.55-1.246-2.285-2.733l1.963-10.999c.265-1.486 1.728-2.69 3.25-2.673 1.522.016 2.55 1.246 2.285 2.732",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB66",
    d: "M119.957 331.098h43.926v-9.994h-43.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F59",
    d: "M137.612 331.098h6.829v-9.994h-6.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC18F",
    d: "M123.766 331.098h3.748v-9.994h-3.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D67B2F",
    d: "M119.957 331.098h43.926v-1.485h-43.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB66",
    d: "M119.957 321.373h43.926v-9.994h-43.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F59",
    d: "M137.612 321.373h6.829v-9.994h-6.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC18F",
    d: "M123.766 321.373h3.748v-9.994h-3.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D67B2F",
    d: "M119.957 321.373h43.926v-1.484h-43.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB66",
    d: "M117.027 311.649h43.926v-9.995h-43.926z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F59",
    d: "M134.682 311.648h6.828v-9.994h-6.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC18F",
    d: "M120.836 311.648h3.747v-9.994h-3.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D67B2F",
    d: "M117.027 311.649h43.926v-1.485h-43.926z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCredits);
export default __webpack_public_path__ + "static/media/no-credits.af9d2469ebd36343c0fa13b5fe893ebf.svg";
export { ForwardRef as ReactComponent };